import { render, staticRenderFns } from "./tryon-dialog.vue?vue&type=template&id=195f5638&scoped=true&"
import script from "./tryon-dialog.vue?vue&type=script&lang=js&"
export * from "./tryon-dialog.vue?vue&type=script&lang=js&"
import style0 from "./tryon-dialog.vue?vue&type=style&index=0&id=195f5638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f5638",
  null
  
)

export default component.exports